import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollProgress = (scrollTop / scrollHeight) * 100;
      
      setProgress(scrollProgress);
      
      if (scrollTop > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={`scroll-wrapper ${isVisible ? "visible" : ""}`}>
      {/* <svg className="scroll-progress" viewBox="0 0 100 100">
        <circle 
          className="scroll-progress-bg" 
          cx="50" 
          cy="50" 
          r="45" 
        />
        <circle 
          className="scroll-progress-bar" 
          cx="50" 
          cy="50" 
          r="45" 
          style={{
            strokeDasharray: 283,
            strokeDashoffset: 283 - (progress / 100) * 283,
          }}
        />
      </svg>
      <button
        className="scroll-to-top"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <ArrowUp size={24} />
      </button> */}
    </div>
  );
};

export default ScrollToTop;